class FacilityCategoryFilters {
	constructor( root ) {
		this.root = root;
		this.panel = root.querySelector( '.js-facilityCategoryFiltersPanel' );
		this.toggle = root.querySelector( '.js-filtersToggle' );
		this.badge = root.querySelector( '.js-filtersBadge' );
		this.selects = [ ...root.querySelectorAll( '.js-facilityCategoryFilter' ) ];
		this.typeLocationSelect = root.querySelector( '[data-filter-group="type-locatie"]' );
		this.hoteltypeSelect = root.querySelector( '[data-filter-group="hoteltype"]' );
		this.results = document.querySelector( '.js-facilityCategoryResults' );
		this.category = root.dataset.facilityCategory || '';

		this.selects.forEach( select => select.addEventListener( 'change', () => {
			this.updateHoteltypeVisibility();
			this.filter();
		} ) );
		if ( this.results ) {
			this.results.addEventListener( 'click', event => this.handlePagination( event ) );
		}
		if ( this.toggle && this.panel ) {
			this.toggle.addEventListener( 'click', () => this.togglePanel() );
		}
		this.updateHoteltypeVisibility();
		this.updateBadge();
	}

	updateHoteltypeVisibility() {
		if ( ! this.typeLocationSelect || ! this.hoteltypeSelect ) return;

		const hoteltypeField = this.hoteltypeSelect.closest( '.p-modelFilters__availField' );
		const isHotels = this.typeLocationSelect.value === 'hotels';
		if ( hoteltypeField ) {
			hoteltypeField.hidden = ! isHotels;
		}
		if ( ! isHotels ) {
			this.hoteltypeSelect.value = '';
		}
	}

	togglePanel() {
		const isOpen = this.toggle.getAttribute( 'aria-expanded' ) === 'true';
		this.toggle.setAttribute( 'aria-expanded', isOpen ? 'false' : 'true' );
		this.panel.hidden = isOpen;
		this.panel.setAttribute( 'aria-hidden', isOpen ? 'true' : 'false' );
	}

	handlePagination( event ) {
		const link = event.target.closest( '.pagination a' );
		if ( ! link ) return;

		const page = Number.parseInt( new URL( link.href ).searchParams.get( 'paged' ), 10 );
		if ( ! Number.isInteger( page ) || page < 1 ) return;

		event.preventDefault();
		this.filter( page );
	}

	async filter( page = 1 ) {
		this.updateBadge();

		if ( ! this.results || ! window.junctionFacilityArchive ) return;

		const data = new FormData();
		data.append( 'action', window.junctionFacilityArchive.action );
		data.append( 'nonce', window.junctionFacilityArchive.nonce );
		data.append( 'page', page );
		data.append( 'facility_category', this.category );
		this.selects.forEach( select => {
			data.append( `facility_filter_${ select.dataset.filterGroup }`, select.value );
		} );

		const cards = this.results.querySelector( '.js-facilityCategoryCards' );
		this.root.setAttribute( 'aria-busy', 'true' );
		if ( cards ) {
			cards.setAttribute( 'aria-busy', 'true' );
		}
		try {
			const response = await fetch( window.junctionFacilityArchive.ajaxUrl, {
				method: 'POST',
				body: data,
			} );
			const result = await response.json();
			if ( ! response.ok || ! result.success ) throw new Error( 'Facility filters could not be updated.' );

			this.results.innerHTML = result.data.html
				? `<div class="b-facilityCategoryCards js-facilityCategoryCards">${ result.data.html }</div>${ result.data.pagination }`
				: `<p>${ window.junctionFacilityArchive.emptyText }</p>`;
		} catch ( error ) {
			console.error( error );
		} finally {
			this.root.removeAttribute( 'aria-busy' );
			this.results.querySelector( '.js-facilityCategoryCards' )?.removeAttribute( 'aria-busy' );
		}
	}

	updateBadge() {
		const selected = this.selects.filter( select => select.value );
		if ( this.badge ) {
			this.badge.textContent = selected.length;
			this.badge.hidden = selected.length === 0;
		}
		this.root.classList.toggle( 'has-filters', selected.length > 0 );
	}
}

document.querySelectorAll( '.js-facilityCategoryFilters' ).forEach( root => {
	if ( root.dataset.facilityCategoryFiltersInit === '1' ) return;
	root.dataset.facilityCategoryFiltersInit = '1';
	new FacilityCategoryFilters( root );
} );
